import dayjs from 'dayjs';
import { groupBy } from 'lodash';

import { ISlot } from '1_shared/config/interfaces/ISlot';

export const getClosestSlots = (slots: ISlot[]) => groupBy(slots, el => dayjs(el.start).format('YYYY-MM-DD'));
